const fetchTinyUrl = (v3ServicesPath, url, baseUrl) => {
  const apiUrl = `${v3ServicesPath}/tiny`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: url,
  };

  return fetch(apiUrl, options)
    .then((response) => response.text())
    .then((tinyUrl) => `${baseUrl}${tinyUrl}`)
    .catch(() => '');
};

export default fetchTinyUrl;
